export default class ActionHelper {
    static createActionObj = (type) => {
        return (payload, promise = {}) => ({
            payload,
            promise,
            type: type,
        })
    }
}
